import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

class StudentRules extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //VARIABLE TO GET PERIODICAL DATA LIST
            ruleDataLoading: false,
            ruleData: {},

        }
    }

    componentDidMount() {
        this.GetInstituteLibraryRules();
    }

    //API CALL METHOD TO GET Institute
    GetInstituteLibraryRules = async () => {
        this.setState({ ruleDataLoading: true })

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteLibraryRules',
            requestData,
            '/api/library/learner.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteLibraryRules();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            ruleData: apiResult.data,
                            ruleDataLoading: false
                        });
                    } else {
                        this.setState({
                            ruleData: {},
                            ruleDataLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        ruleData: {},
                        ruleDataLoading: false,
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    render() {
        const { ruleData } = this.state;
        const generalRules = ruleData.general?.rule_description || "";
        const studentRules = ruleData.student || {};

        return (
            <>
                <RoutingMenu activeScreen="userRules" />

                <div className="libraryComponents-container pr-6 pl-6">
                    {/* Page Heading */}
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4 className="text-xl font-semibold">Library Rules</h4>
                        </div>
                    </div>

                    {/* Library Info Card */}
                    <div className="bg-white border border-gray-200 p-3 mb-6" style={{ borderRadius: "12px" }}>
                        <div className="flex items-start gap-4">
                            {this.state.ruleDataLoading ? (
                                <ButtonLoader />
                            ) : generalRules ? (
                                ReactHtmlParser(generalRules)
                            ) : (
                                <p className="text-sm text-gray-500 mt-2">
                                    Please add the general rules for library from 'Action' menu.
                                </p>
                            )}

                        </div>
                    </div>

                    {/* Policy Table */}
                    <div className="bg-white border border-gray-200 overflow-hidden mt-4" style={{ borderRadius: "12px" }}>
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area">
                                <table className="table table-bordered  vm_libraryReport_table" id="studentGeneralRules">
                                    <thead>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="3"></th>
                                            </tr>
                                            <th>Policy</th>
                                            <th>Rule</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.ruleDataLoading ?
                                                <tr>
                                                    <td colSpan="3">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                Object.keys(studentRules).map((key, index) => {
                                                    const rule = studentRules[key];
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <tr className="border-t">
                                                                <td
                                                                    rowSpan="5"
                                                                    className="align-top py-4 px-4 font-medium text-gray-700"
                                                                >
                                                                    {rule.name}
                                                                </td>
                                                                <td className="py-3 px-4 border-t">Number of resources / periodicals can hold</td>
                                                                <td className="py-3 px-4 border-t">{rule.NumberOfResources}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Number of days resources / periodicals can hold</td>
                                                                <td className="py-3 px-4 border-t">{rule.NumberOfDays}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Fine per day (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.PerDayFine}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Resource damaged cost (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.ResourceDamagedCost}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Resource lost cost (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.ResourceLostCost}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    );
                                                })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        );
    }

}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentRules);